import { useTranslation } from "react-i18next";
import ListGroup, { ListGroupItem } from "./controls/ListGroup";
import Grid from "./layout/Grid";
import Row from "./layout/Row";
import Col from "./layout/Col";
import Label from "./controls/Label";

import LinkButton from "./controls/LinkButton";
import TrashIcon from "./icon/TrashIcon";
import { Formik } from "formik";
import { MedicionSchema } from "../data/MedicionSchema";
import TypeaheadField from "./controls/TypeaheadField";
import SelectField from "./controls/SelectField";
import { isInvalid } from "../utils/forms";
import AmmountField from "./controls/AmmountField";
import PlusIcon from "./icon/PlusIcon";
import { decode } from "he";

export function MedicionForm({
  value,
  append,
  remove,
  contaminantes,
  disabled,
}) {
  const { t } = useTranslation();
  const handleContaminanteChange = (form) => (event) => {
    form.handleChange(event);
  };
  const handleSignoChange = (form) => (event) => {
    form.handleChange(event);
  };
  const handleCantidadChange = (form) => (event) => {
    form.handleChange(event);
  };
  return (
    <ListGroup>
      <ListGroupItem>
        <Grid>
          <Row>
            <Col lg={1}>#</Col>
            <Col lg={4}>{t("medicion.contaminante")}</Col>
            <Col lg={2}>{t("medicion.signo")}</Col>
            <Col lg={4}>{t("medicion.cantidad")}</Col>
          </Row>
        </Grid>
      </ListGroupItem>
      {value.map((medicion, index) => (
        <ListGroupItem key={medicion.contaminante.codigo}>
          <Grid>
            <Row>
              <Col lg={1}>
                <Label>{index + 1}</Label>
              </Col>
              <Col lg={4}>
                <Label>{medicion?.contaminante.nombre}</Label>
              </Col>
              <Col lg={2}>
                <Label>{medicion?.signo}</Label>
              </Col>
              <Col lg={4}>
                <Label>
                  {medicion?.cantidad.magnitud}&nbsp;
                  {decode(medicion?.cantidad?.unidad?.html)}
                </Label>
              </Col>
              <Col lg={1}>
                <LinkButton
                  sm
                  style={{ margin: 0, fontSize: "16px" }}
                  onClick={(event) => {
                    event.preventDefault();
                    remove(index);
                  }}
                  disabled={disabled}
                >
                  <TrashIcon />
                </LinkButton>
              </Col>
            </Row>
          </Grid>
        </ListGroupItem>
      ))}
      <ListGroupItem>
        <Formik
          initialValues={MedicionSchema.cast(undefined, { assert: false })}
          validationSchema={MedicionSchema}
          onSubmit={(values, { resetForm }) => {
            append(values);
            resetForm({
              values: MedicionSchema.cast(undefined, { assert: false }),
            });
          }}
        >
          {(form) => (
            <Grid>
              <Row>
                <Col lg={1}>
                  <Label>*</Label>
                </Col>
                <Col lg={4}>
                  <TypeaheadField
                    id="caracterizacionEfluenteCrudo_medicion_contaminante"
                    name="contaminante"
                    value={form.values.contaminante}
                    onChange={handleContaminanteChange(form)}
                    options={contaminantes?.filter(
                      (contaminante) =>
                        value.findIndex(
                          (medicion) =>
                            medicion.contaminante.codigo ===
                            contaminante.codigo,
                        ) < 0,
                    )}
                    labelAttr="nombre"
                    valueAttr="codigo"
                    emptyLabel="..."
                    style={{ margin: 0 }}
                    isInvalid={isInvalid("contaminante", form)}
                    error={t(form.errors.contaminante)}
                    disabled={disabled}
                  />
                </Col>
                <Col lg={2}>
                  <SelectField
                    id="caracterizacionEfluenteCrudo_medicion_signo"
                    name="signo"
                    value={form.values.signo}
                    onChange={handleSignoChange(form)}
                    options={["=", "<", ">"]}
                    style={{ margin: 0 }}
                    emptyLabel="..."
                    isInvalid={isInvalid("signo", form)}
                    error={t(form.errors.signo)}
                    disabled={disabled || !form.values.contaminante}
                  />
                </Col>
                <Col lg={4}>
                  <AmmountField
                    id="caracterizacionEfluenteCrudo_medicion_cantidad"
                    name="cantidad"
                    value={form.values.cantidad}
                    onChange={handleCantidadChange(form)}
                    unit={form.values.contaminante?.unidad}
                    style={{ margin: 0 }}
                    isInvalid={isInvalid("cantidad", form)}
                    error={t(form.errors.cantidad)}
                    disabled={disabled || !form.values.contaminante}
                  />
                </Col>
                <Col lg={1}>
                  <LinkButton
                    sm
                    style={{ margin: 0, fontSize: "16px" }}
                    onClick={(event) => {
                      event.preventDefault();
                      form.submitForm();
                    }}
                    disabled={disabled}
                  >
                    <PlusIcon />
                  </LinkButton>
                </Col>
              </Row>
            </Grid>
          )}
        </Formik>
      </ListGroupItem>
    </ListGroup>
  );
}
